export enum RiskAssessmentAction {
  Edit = 1,
  EditAndPerform = 2,
  Perform = 3,
}
